module.exports = __webpack_public_path__ + "static/img/Volti.970e31f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/nets/Volti.png
// module id = eM36
// module chunks = 0